/*
 * File: base-input-component.ts
 * File Created: 2024-01-14 10:46:50
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-03-13 01:58:02
 * Modified By: Val Liu
 * -----
 */

import { BaseComponent } from "@root/components/base-classes";
import { IFormState } from "@root/components/form/core/lib/core";
import { Component, Prop } from "vue-property-decorator";
import { IMultiple } from "./core";

@Component
export class BaseInputComponent extends BaseComponent {
    /// The main placeholder for this form component.
    @Prop({ type: String, required: false })
    placeholder: string | undefined;

    /// the true | false | null | undefined state
    @Prop({ required: false })
    state: IFormState;

    /// allow multiple value
    @Prop({ type: [String, Boolean], default: false })
    multiple!: IMultiple;

    /// gradual input
    @Prop({ type: Boolean, default: true })
    strict!: boolean;

    /// prepend / append text
    @Prop({ type: String, required: false })
    prepend?: string;

    @Prop({ type: String, required: false })
    append?: string;

    /// private helpers
    get customInputClasses() {
        return {
            "form-control": true,
            disabled: this.disabled,
            [`size-${this.size}`]: true,
            "is-valid": this.state === true,
            "is-invalid": this.state === false,
        };
    }
}
